/* ============================================================
   jab-geo.js
   Jabree geolocation SUGGESTION banner (snippets/jab-geo-banner.liquid).

   The store is on Basic, so Shopify's automatic country redirect (Plus only)
   is unavailable and every cold visitor lands in the US/USD market. This
   implements Shopify's documented non-Plus alternative: ask
   /browsing_context_suggestions.json what the visitor's optimal localization
   is, and if it differs from the current one, offer a prompt.

   It NEVER auto-redirects. The visitor has to press the button.

   Shown at most once per browsing session (sessionStorage), and never again
   after a dismissal (localStorage key "jabGeoDismissed").
   ============================================================ */
(function () {
  'use strict';

  var DISMISS_KEY = 'jabGeoDismissed';
  var SESSION_KEY = 'jabGeoShown';

  /* Storage is unavailable / throws in iOS private mode and some in-app
     browsers, so every access is guarded. Failure degrades to "no memory",
     never to a thrown error. */
  function safeGet(store, key) {
    try {
      return window[store].getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(store, key, value) {
    try {
      window[store].setItem(key, value);
    } catch (e) {
      /* ignore */
    }
  }

  function init() {
    var root = document.getElementById('jab-geo');
    if (!root) return;

    if (safeGet('localStorage', DISMISS_KEY)) return;
    if (safeGet('sessionStorage', SESSION_KEY)) return;

    var flagEl = root.querySelector('[data-jab-geo="flag"]');
    var copyEl = root.querySelector('[data-jab-geo="copy"]');
    var acceptEl = root.querySelector('[data-jab-geo="accept"]');
    var dismissEl = root.querySelector('[data-jab-geo="dismiss"]');
    var formEl = root.querySelector('[data-jab-geo="form"]');
    var codeEl = root.querySelector('[data-jab-geo="country-code"]');
    var dataEl = root.querySelector('[data-jab-geo="countries"]');

    if (!copyEl || !acceptEl || !dismissEl || !formEl || !codeEl || !dataEl) return;

    var countries = {};
    try {
      countries = JSON.parse(dataEl.textContent) || {};
    } catch (e) {
      return;
    }

    var shopify = window.Shopify || {};
    var routeRoot = (shopify.routes && shopify.routes.root) || '/';
    var current =
      root.getAttribute('data-current-country') || shopify.country || '';

    /* Dismiss is wired up before the fetch so the control is never inert. */
    dismissEl.addEventListener('click', function () {
      safeSet('localStorage', DISMISS_KEY, '1');
      close();
    });

    function close() {
      root.classList.remove('is-open');
      root.setAttribute('hidden', '');
    }

    /* Defensive read of the suggestions payload. Observed shape (verified
       against www.jabree.xyz):
         { detected_values: { country_name, country: { handle, name } },
           features: { duties_collected },
           suggestions: [ { parts: { country: { handle, name, confidence,
                                                options: { ISO: Name } } },
                            confidence } ] }
       Anything unexpected simply yields null and the banner stays hidden. */
    function pickCountry(data) {
      if (!data || typeof data !== 'object') return null;

      var list = data.suggestions;
      if (Object.prototype.toString.call(list) === '[object Array]') {
        for (var i = 0; i < list.length; i++) {
          var parts = list[i] && list[i].parts;
          var c = parts && parts.country;
          if (c && c.handle) return c.handle;
        }
      }

      var detected = data.detected_values && data.detected_values.country;
      if (detected && detected.handle) return detected.handle;

      return null;
    }

    var url =
      routeRoot +
      'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(current);

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('bad status ' + res.status);
        return res.json();
      })
      .then(function (data) {
        var handle = pickCountry(data);
        if (!handle) return;

        /* Never prompt for where they already are, and never prompt for a
           country this shop does not actually sell to. */
        if (handle === current) return;

        var entry = countries[handle];
        if (!entry || !entry.currency) return;

        /* Suggesting a country that happens to use the currency already on
           screen would read as a no-op to the shopper. */
        if (entry.currency === root.getAttribute('data-current-currency')) return;

        var name = entry.name || handle;

        copyEl.textContent =
          "Looks like you're in " + name + '. Shop in ' + entry.currency + '?';
        acceptEl.textContent = 'Shop in ' + entry.currency;
        acceptEl.setAttribute(
          'aria-label',
          'Switch to ' + name + ' and shop in ' + entry.currency
        );

        if (flagEl && entry.flag) {
          flagEl.style.backgroundImage = 'url(' + entry.flag + ')';
        }

        acceptEl.addEventListener('click', function () {
          /* Remember the choice so the prompt does not reappear after the
             localization POST reloads the page. */
          safeSet('localStorage', DISMISS_KEY, '1');
          codeEl.value = handle;
          formEl.submit();
        });

        safeSet('sessionStorage', SESSION_KEY, '1');

        root.removeAttribute('hidden');
        /* Next frame, so the opacity/transform transition actually runs
           instead of being collapsed with the un-hide. */
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            root.classList.add('is-open');
          });
        });
      })
      .catch(function () {
        /* Endpoint unavailable or blocked: stay silent and hidden. */
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
